import React from "react";

const CardSimulateAgain = ({
  cardRef,
  activeSlide,
  index,
  options,
  CategoryGeneric,
  shouldBeFullHeight,
}) => {
  return (
    <div
      data-testid="card-simulate-again"
      ref={cardRef}
      className={`carousel-plan-item ${
        activeSlide === index ? "" : "carousel-plan-item--unavailable"
      }`}
    >
      <div
        data-testid="card-simulate-container"
        className={`simular-novamente-container ${
          cardRef && cardRef.current && cardRef.current.clientHeight < 300
            ? "simular-novamente-container--small"
            : ""
        }`}
      >
        <span
          data-testid="card-simulate-message"
          className={`carousel-plan-message  ${
            shouldBeFullHeight(options) ? "carousel-plan-message--top" : ""
          }`}
        >
          Não encontrou um plano adequado às suas necessidades? Faça uma nova
          simulação.
        </span>
        <img
          data-testid="simular-novamente-img"
          src={CategoryGeneric}
          alt="Opção simular novamente"
          className="simular-novamente-img"
        />
        <span className="carousel-plan-medium">Faça uma nova simulação</span>
      </div>
    </div>
  );
};

export default CardSimulateAgain;
